import React from 'react'

import { Typography } from '@material-ui/core'

import { PRICING } from 'artkive/utils/constants'

import { DisclaimerSection } from './BoxDueDisclaimer.style'

const BoxDueDisclaimer = () => (
  <DisclaimerSection>
    <Typography>
      *Your Artkive Box is due back within {PRICING.books.dueBackMonths} months of the purchase date. If your box isn’t
      ready to send back by then, no worries—we’ll simply process a deposit covering the first {PRICING.books.minPages}{' '}
      pieces in your book (${PRICING.books.base}) on your box's {PRICING.books.dueBackMonths}-month due date. The
      deposit will then be credited toward your final order total once your box is sent in.
    </Typography>
  </DisclaimerSection>
)

export default BoxDueDisclaimer
